import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import {
  fetchDeleteDeliveryInfoItem,
  fetchGetAdminCompanies,
  fetchGetAdminDeliveryInfo,
} from '../../../../../actions/admin';
import { parseError, preventSubmittingByEnter } from '../../../../../helpers';
import { DELIVERY_INFO_MODS } from '../../../../../config';
import { SelectWrapper, TableContainer } from '../styled';
import { toast } from 'react-toastify';
import SelectComponent from '../../../../common/Select';
import { showModal } from '../../../../../actions/modal';

const ACTIVE_OPTIONS = [
  { label: 'Все', value: null },
  { label: 'Да', value: true },
  { label: 'Нет', value: false },
];

const List = (props) => {
  const { values, handleSubmit, handleSwitchMode, services } = props;

  const dispatch = useDispatch();
  const { companies } = useSelector((state) => state.admin);
  const [companiesState, setCompaniesState] = useState(null);
  const [activeOption, setActiveOption] = useState(ACTIVE_OPTIONS[0]);
  const [currentService, setCurrentService] = useState(null);
  const [listOfOptions, setListOfOptions] = useState([]);

  const handleService = (value) => {
    setCurrentService(value);
  };

  useEffect(() => {
    dispatch(fetchGetAdminDeliveryInfo());
    dispatch(fetchGetAdminCompanies());
  }, []);

  useEffect(() => {
    if (companies !== null) {
      setCompaniesState(
        companies.map((item) => {
          return { label: item, value: item };
        }),
      );
    }
  }, [companies, dispatch]);

  useEffect(() => {}, [companies]);

  const handleRemoveItem = (code) => {
    dispatch(fetchDeleteDeliveryInfoItem(code))
      .then(() => {
        toast.info('Элемент был успешно удален');
        dispatch(fetchGetAdminDeliveryInfo());
        dispatch(fetchGetAdminCompanies());
      })
      .catch((err) => {
        toast.error(parseError(err));
      });
  };

  const handleConfirmDeleteItem = (item) => {
    dispatch(
      showModal('ConfirmDelete', {
        body: item.title,
        image: item.imgUrl,
        handleConfirm: () => handleRemoveItem(item.code),
      }),
    );
  };

  return (
    <form onKeyDown={preventSubmittingByEnter} onSubmit={handleSubmit}>
      {values && (
        <TableContainer>
          <div className="fixed-table-container">
            <div className="fixed-table-body">
              <table className="table table-centered">
                <thead className="thead-light">
                  <tr>
                    <th />
                    <th>Изображение</th>
                    <th>
                      <SelectComponent
                        label="Активен"
                        options={ACTIVE_OPTIONS}
                        value={activeOption}
                        onChange={(value) => setActiveOption(value)}
                        isClearable={false}
                        style={{ width: '100%' }}
                      />
                    </th>
                    <th>
                      Виден <br /> покупателю
                    </th>
                    <th>Название договора</th>
                    <th>
                      <SelectComponent
                        label="Название КС"
                        options={services}
                        value={currentService}
                        onChange={(value) => handleService(value)}
                        isClearable={true}
                        isSearchable
                      />
                    </th>
                    <th>Продукт</th>
                    <th>Номер договора</th>
                    <th>Внешний код / DLV id</th>
                    <th>Кактус id</th>
                  </tr>
                </thead>
                <tbody>
                  {values.deliveryInfo &&
                    values.deliveryInfo
                      ?.sort((a, b) => a.title.localeCompare(b.title))
                      .filter((item) =>
                        activeOption === ACTIVE_OPTIONS[0]
                          ? item
                          : item.active === activeOption.value,
                      )
                      .filter((item) =>
                        currentService === null
                          ? item
                          : currentService?.value === 'SELF_PICKUP_WAREHOUSE'
                          ? item.deliveryType === currentService?.value
                          : item.courierTitle === currentService?.label,
                      )
                      .map((item, index) => (
                        <tr key={item.uid}>
                          <td style={{ minWidth: '45px', maxWidth: '45px' }}>
                            <section className="correction-data">
                              <div
                                style={{ display: 'flex', flexDirection: 'column', rowGap: '8px' }}
                              >
                                <i
                                  className="fe-edit edit-icon action-icon"
                                  onClick={() => handleSwitchMode(DELIVERY_INFO_MODS.EDIT, item)}
                                  title="Изменить"
                                />
                                <i
                                  className="fe-trash edit-icon action-icon"
                                  onClick={() => handleConfirmDeleteItem(item)}
                                  title="Удалить"
                                />
                              </div>
                            </section>
                          </td>
                          <td style={{ minWidth: '110px', maxWidth: '110px' }}>
                            {item.imgUrl && <img src={item.imgUrl} alt={item.title} width="100" />}
                          </td>
                          <td style={{ minWidth: '100px', maxWidth: '100px' }}>
                            {item.active && <i className="fe-check green-check" />}
                          </td>
                          <td style={{ minWidth: '90px', maxWidth: '90px' }}>
                            {item.publicAvailable && <i className="fe-check green-check" />}
                          </td>
                          <td style={{ minWidth: '160px', maxWidth: '160px' }}>
                            {item.title ? item.title : ''}
                          </td>
                          <td style={{ minWidth: '165px', maxWidth: '165px' }}>
                            {item.courierTitle ? item.courierTitle : ''}
                          </td>
                          <td style={{ minWidth: '160px', maxWidth: '160px' }}>
                            {item.product ? item.product : ''}
                          </td>
                          <td style={{ minWidth: '160px', maxWidth: '160px' }}>
                            {item.contractNumber ? item.contractNumber : ''}
                          </td>
                          <td style={{ minWidth: '180px', maxWidth: '180px' }}>
                            {item.deliveryCode ? item.deliveryCode : ''}
                          </td>
                          <td style={{ minWidth: '180px', maxWidth: '180px' }}>
                            {item.code ? item.code : ''}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>
          </div>
        </TableContainer>
      )}
    </form>
  );
};

export default List;
